import { FC, useEffect, useState } from 'react';

import { getVuzFaculties, getVuzSpecialities } from 'api';
import { useComponentDidMount } from 'hooks';

import { VuzCard } from '../../components';
import { ILocalVuzSpeciality, ISearchVuz, IVuzInfoWithSearchPosition } from '../../types';
import { convertVuzSpecialityToLocal } from '../../utils';
import { complementSearchWithFacultySpecialities, flatenSpecialities } from '../utils';

interface IVuzCardContainerProps {
  vuz: ISearchVuz;
  searchPosition: number;
}

const VuzCardContainer: FC<IVuzCardContainerProps> = ({ vuz, searchPosition }) => {
  const { info, specialities } = vuz;
  const { id } = info;
  const [specialitiesNumber, setSpecialitiesNumber] = useState<number | null>(null);
  const [localSpecialities, setLocalSpecialities] = useState<ILocalVuzSpeciality[] | null>(null);
  const [allLocalSpecialities, setAllLocalSpecialities] = useState<ILocalVuzSpeciality[] | []>([]);
  const [facultySpecialities, setFacultySpecialities] = useState<ILocalVuzSpeciality[] | null>(null);
  const resultSpecialities = localSpecialities ?? specialities;
  const searchParams = {
    per_page: 9999,
    page: 1,
  };
  useComponentDidMount(() => {
    async function getSpecialities() {
      if (!id) return;
      const { response } = await getVuzSpecialities(id, searchParams);

      setSpecialitiesNumber(response?.items.length || null);
      if (response?.items && response?.items.length) {
        setAllLocalSpecialities(response.items.flatMap(convertVuzSpecialityToLocal) || []);
      }
    }
    async function getFaculties() {
      if (!id) return;
      const { response } = await getVuzFaculties(id, searchParams);
      setFacultySpecialities(flatenSpecialities(response?.items || []));
    }

    getSpecialities();
    getFaculties();
  });

  useEffect(() => {
    if (!facultySpecialities) return;
    // по умолчанию если не выбраны фильтры по предметам показываем все специальности
    const spec = specialities && specialities.length ? specialities : allLocalSpecialities;
    const mergedSpecialities = complementSearchWithFacultySpecialities(spec, facultySpecialities);
    setLocalSpecialities(mergedSpecialities);
  }, [facultySpecialities, specialities, allLocalSpecialities]);

  const budgetPlaces = resultSpecialities.reduce((counter, item) => {
    return counter + (item?.budgetPlaces ?? 0);
  }, 0);

  const vuzInfo: IVuzInfoWithSearchPosition = {
    ...info,
    specialitiesNumber: specialitiesNumber ?? info.specialitiesNumber,
    budgetPlaces,
    searchPosition,
  };

  return <VuzCard vuzInfo={vuzInfo} specialities={resultSpecialities} />;
};

export default VuzCardContainer;
